import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignVerticalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAlignVerticalCenter"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM7 11.25V12.75H17V11.25H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignVerticalCenter;
